// eslint-disable-next-line no-unused-vars
export const _colors = {
  BORDO: "rgba(155, 39, 67, 1)",
  GRAY: "rgba(58, 67, 78, 1)",
  BLACK: "rgba(18, 18, 18, 1)",
  WHITE: "rgba(255, 255, 255, 1)",
};
